/**
 * 仪表盘国际化 - 中文
 */
export default {
  'dashboard.title': '垃圾房投递口管理',
  'dashboard.subtitle': '实时监控垃圾房运行状态',
  
  // 统计卡片
  'dashboard.statistics.totalRooms': '垃圾房总数',
  'dashboard.statistics.totalRooms.desc': '当前运行中的垃圾房',
  'dashboard.statistics.totalPorts': '投递口总数',
  'dashboard.statistics.totalPorts.desc': '所有投递口总数',
  'dashboard.statistics.overflowPorts': '满溢投口数量',
  'dashboard.statistics.overflowPorts.desc': '需要及时处理',
  'dashboard.statistics.normalPorts': '未满投口数量',
  'dashboard.statistics.normalPorts.desc': '运行正常',
  
  // 表格列
  'dashboard.table.name': '名称',
  'dashboard.table.name.placeholder': '请输入垃圾房名称',
  'dashboard.table.tvocLevel': 'TVOC浓度',
  'dashboard.table.overflowCount': '满溢数量',
  'dashboard.table.normalCount': '未满数量',
  'dashboard.table.deodorizerStatus': '除臭机状态',
  'dashboard.table.uvLightStatus': '紫外灯状态',
  'dashboard.table.action': '操作',
  'dashboard.table.action.detail': '详情',
  
  // 状态
  'dashboard.status.on': '开启',
  'dashboard.status.off': '关闭',
  
  // 详情抽屉
  'dashboard.detail.title': '垃圾房详情',
  'dashboard.detail.basicInfo': '基本信息',
  'dashboard.detail.name': '垃圾房名称',
  'dashboard.detail.tvocLevel': 'TVOC浓度',
  'dashboard.detail.overflowCount': '满溢数量',
  'dashboard.detail.normalCount': '未满数量',
  'dashboard.detail.deodorizerStatus': '除臭机状态',
  'dashboard.detail.uvLightStatus': '紫外灯状态',
  'dashboard.detail.address': '详细地址',
  'dashboard.detail.portsInfo': '投递口状态',
  'dashboard.detail.portsList': '投递口列表',
  
  // 消息提示
  'dashboard.message.controlSuccess': '操作成功',
  'dashboard.message.controlFailed': '操作失败',
  'dashboard.message.getDetailFailed': '获取详情失败',
  'dashboard.message.deodorizerOn': '除臭机已开启',
  'dashboard.message.deodorizerOff': '除臭机已关闭',
  'dashboard.message.uvLightOn': '紫外灯已开启',
  'dashboard.message.uvLightOff': '紫外灯已关闭',
}

